var scope_0 = require('C:/src/hotchocolate/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7206032b394a8220312dddcb7fc4877e.js').default;
var scope_1 = require('C:/src/hotchocolate/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    